import { useAuth } from "@/hooks/useAuth";
import ProfileCompletion from "@/components/ProfileCompletion";

export default function ProfileCompletionGuard({ children }) {
  const { user } = useAuth();

  // Check if profile is incomplete (Google OAuth users without SA ID)
  // Only apply to patients, not doctors or practice owners
  const isProfileIncomplete = 
    user && 
    user.userType === "patient" &&
    user.provider === "google" && 
    !user.identificationNumber;

  // If profile is incomplete, show the profile completion form
  if (isProfileIncomplete) {
    return <ProfileCompletion onComplete={() => window.location.reload()} />;
  }

  // Otherwise, render the children (the actual page content)
  return children;
}